import {Box, Button, Flex, StackDivider, Text} from '@chakra-ui/react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  jcRaceFinishTimesAdminSortSet,
  jcRaceFinishTimesListRequest
} from '../../reducers/gooodReducer';
import Filters from '../WooorldInApp/Filters';
import PageTitle from '../WooorldInApp/PageTitle';
import TableEditor from './TableEditor';
import {jetpackClankers} from 'common';

dayjs.extend(duration);

const dateToLabel = value => value ? new Date(value).toLocaleString() : '';

const finishTimeToLabel = value => {
  if (value === null || value === undefined) return '';
  const finishDuration = dayjs.duration(Math.round(Number(value) * 1000));
  const minutes = String(Math.floor(finishDuration.asMinutes())).padStart(2, '0');
  const seconds = String(finishDuration.seconds()).padStart(2, '0');
  const milliseconds = String(finishDuration.milliseconds()).padStart(3, '0');
  return `${minutes}:${seconds}.${milliseconds}`;
};

const idToLabel = value => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  return value.alias || value.name || value._id || value.id || JSON.stringify(value);
};

const JcRaceFinishTimesTable = () => {
  const {
    error,
    isLoading,
    response,
    sort,
    sortOptions,
  } = useSelector(s => s.goood.jcRaceFinishTimesAdmin);
  const items = (response || []).map(item => ({
    ...item,
    trackId: jetpackClankers.raceTracksById[item.trackId].label,
    userAlias: item.user?.alias || idToLabel(item.user),
  }));
  const dispatch = useDispatch();

  useEffect(() => {
    if (!response && !isLoading && !error) {
      dispatch(jcRaceFinishTimesListRequest({}));
    }
  }, [response, isLoading, error]);

  const handleSortClick = (sortClicked) => () => {
    dispatch(jcRaceFinishTimesAdminSortSet(sortClicked));
  };

  return (
    <Box width="full">
      <PageTitle title="jcRaceFinishTimes - Goood"/>
      <Flex justifyContent="flex-end" p={4}>
        <Filters isSortOnly>
          <Text color="lightgrey">Sort by</Text>
          {sortOptions.map(({value, label}, idx) => {
            const isSelected = sort === value;
            return (
              <Button
                colorScheme={isSelected ? 'wooorldBlue' : null}
                key={idx}
                justifyContent="left"
                onClick={handleSortClick(value)}
                position="relative"
                size="sm"
              >
                {label}
              </Button>
            );
          })}
          <StackDivider border="solid grey"/>
        </Filters>
      </Flex>
      <TableEditor
        error={error}
        fields={[
          {
            isReadOnly: true,
            key: '_id',
            valToLabel: idToLabel,
          },
          {
            isReadOnly: true,
            key: 'createdOn',
            valToLabel: dateToLabel,
          },
          {
            isReadOnly: true,
            key: 'finishTimeSeconds',
            valToLabel: finishTimeToLabel,
          },
          {
            isReadOnly: true,
            key: 'rank',
          },
          {
            isReadOnly: true,
            key: 'trackId',
          },
          {
            isReadOnly: true,
            key: 'leaderboardEntry',
            valToLabel: idToLabel,
          },
          {
            isReadOnly: true,
            key: 'userAlias',
          },
        ]}
        isLoading={isLoading}
        items={items}
        title="jcRaceFinishTimes"
      />
    </Box>
  );
};

export default JcRaceFinishTimesTable;
